import * as Sentry from "@sentry/react"

export const logError = (message: string, error: Error) => {
  if (process.env.NODE_ENV === "development") {
    console.error(message, error)
  } else {
    Sentry.captureException(error)
  }
}
